export function appendEmbeddedSocialScript(url) {
  const scriptElement = document.createElement('script');
  scriptElement.setAttribute('src', url);
  scriptElement.setAttribute('defer', 'defer');
  document.head.append(scriptElement);
}
